import React, { useContext, useEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";

// Contexts
import { DataContext } from "~/contexts/Data";

// External components
import { BsPlus } from "react-icons/bs";
import { HiHeart } from "react-icons/hi";

// Internal components
import InternalOrExternalLink from "~/components/InternalOrExternalLink";
import BgVideo from "~/components/BgVideo";

// Routes
import Home from "~/routes/Home";
import NotFound from "~/routes/NotFound";
import SearchResults from "~/routes/SearchResults";
import Page from "~/routes/Page";
import SubPage from "~/routes/SubPage";
import SubSubPage from "~/routes/SubSubPage";
import HeaderBg from "./HeaderBg";
import LazyBlur from "./LazyBlur";

const AllRoutes = () => {
  const {
    umbData,
    setPath,
    path,
    screenWidth,
    headerBgImg,
    headerHeight,
    scrollDirection,
    mobileMenu,
    routes,
  } = useContext(DataContext);
  const { pathname } = useLocation();
  useEffect(() => {
    if (path !== pathname) {
      setPath(pathname);
    }
  });
useEffect(() => {
  const host = document.querySelector("#chattrick-container");
  const shadow = host?.shadowRoot;
  const btn = shadow?.querySelector("#chattrick-mount button");
  if (!btn) return;

  const shouldHide = scrollDirection === "down" || mobileMenu;

  if (shouldHide) {
    btn.style.setProperty("display", "none", "important");
  } else {
    btn.style.removeProperty("display");
  }
}, [scrollDirection, mobileMenu]);
useEffect(() => {
  const injectStyles = (shadow) => {
    if (shadow.querySelector("#custom-chattrick-style")) return;

    const isRoot = pathname === "/";

    const style = document.createElement("style");
    style.id = "custom-chattrick-style";
    style.textContent = `
      #chattrick-mount button {
        ${isRoot ? "bottom: 4rem !important;" : ""}
      }
    `;

    shadow.appendChild(style);
  };

  const host = document.querySelector("#chattrick-container");
  if (!host) return;

  if (host.shadowRoot) {
    injectStyles(host.shadowRoot);
    return;
  }

  const observer = new MutationObserver(() => {
    if (host.shadowRoot) {
      injectStyles(host.shadowRoot);
      observer.disconnect();
    }
  });

  observer.observe(host, { childList: true });

  return () => observer.disconnect();
}, [pathname]);
  return (
    <>
      {/* <Nav /> */}
      <Routes>
        <>
          {/* SEARCH page */}
          <Route path="/sok" exact element={<SearchResults />}></Route>

          {/* PAGE LEVEL 2 - e.g /aktuelt/nyhetsarkiv/fylkesmesse */}
          {umbData.children?.map((page) =>
            page.children?.map((subPage) =>
              subPage.children?.map((subSubPage) => (
                <Route
                  path={subSubPage.url}
                  exact
                  key={subSubPage.url + "route"}
                  element={
                    <SubSubPage
                      page={page}
                      subPage={subPage}
                      subSubPage={subSubPage}
                      tabTitle={`${page.title.toLowerCase()} - ${subPage.title.toLowerCase()} - ${subSubPage.title.toLowerCase()}`}
                    />
                  }
                ></Route>
              )),
            ),
          )}

          {/* PAGE LEVEL 2 - e.g /aktuelt/nyhetsarkiv */}
          {umbData.children?.map((page) =>
            page.children?.map((subPage) => (
              <Route
                path={subPage.url}
                exact
                key={subPage.url + "route"}
                element={
                  <>
                    <SubPage
                      page={page}
                      subPage={subPage}
                      tabTitle={`${page.title.toLowerCase()} - ${subPage.title.toLowerCase()}`}
                    />
                  </>
                }
              ></Route>
            )),
          )}

          {/* PAGE LEVEL 1 - e.g /aktuelt */}
          {umbData?.children &&
            umbData?.children?.map((page) => (
              <Route
                path={page.url}
                exact
                key={page.url + "route"}
                element={<Page page={page} tabTitle={page.title} />}
              ></Route>
            ))}

          {/* PAGE LEVEL  - e.g / */}
          {umbData && <Route path="/" exact element={<Home />}></Route>}

          {/* 404 page */}
          <Route path="*" element={<NotFound />}></Route>
        </>
      </Routes>
      {umbData && (pathname === "/" || mobileMenu) && (
        <div
          className={`nav__bottom-bar d-lg-none ${
            scrollDirection === "down" && !mobileMenu ? "hide" : "show"
          }`}
        >
          {umbData.sokNa?.url && (
            <InternalOrExternalLink
              to={umbData.sokNa.url}
              className="btn btn--blue-gradient px-3 py-2"
            >
              {umbData.sokNa.label}
              <BsPlus size="3rem" className="btn__icon btn__icon--lg ms-2" />
            </InternalOrExternalLink>
          )}
          {umbData.give?.url && (
            <InternalOrExternalLink
              to={umbData.give?.url}
              className="btn btn--light-red px-3 py-2"
            >
              <HiHeart size="1.5rem" className="me-2" />
              Gi en gave
            </InternalOrExternalLink>
          )}
        </div>
      )}
      {umbData ? (
        <>
          {umbData.bgVideo && pathname === "/" ? (
            <BgVideo c={umbData.bgVideo} />
          ) : (
            <>
              {/* <div
                style={{
                  position: "fixed",
                  color: "#fff",
                  zIndex: 999,
                  top: 0,
                  left: 0,
                  background: "rgba(0,0,0,1)",
                  width: 600,
                  whiteSpace: "pre-wrap",
                }}
              >
                <pre style={{ whiteSpace: "pre-wrap" }}>
                  {JSON.stringify(
                    { headerBgImg, "umbData.bgImg": umbData.bgImg },
                    null,
                    1
                  )}
                </pre>
              </div> */}
              <HeaderBg
                screenWidth={screenWidth}
                src={headerBgImg || umbData.bgImg?.umbracoFile}
                title={umbData.bgImg?.title}
                headerHeight={headerHeight}
              />
            </>
          )}
        </>
      ) : null}
    </>
  );
};

export default AllRoutes;
